export default __webpack_public_path__ + "static/media/luna.441d87cf.svg";